import api from './config';

export const submitFeedback = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post('/feedback', formData, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`,
                'Content-Type': 'multipart/form-data'
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 